import React, { useState, useEffect, useMemo, memo } from "react";
import DataTable from "react-data-table-component";
import apiCaller from "../../api/ApiCaller";

const PaginationDataTable = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const customStyles = {
        rows: {
            style: {
                overflow: "visible !important",
                width: "auto",
            },
        },
        headCells: {
            style: {
                minWidth: "153px !important",
                // maxWidth: "200px !important"
                // paddingLeft: '8px', // override the cell padding for head cells
                // paddingRight: '8px',
            },
        },
        cells: {
            style: {
                overflow: "visible !important",
                // minWidth: "140px"
                minWidth: "153px !important",
                // maxWidth: "200px !important"
            },
        },
    };

    const [columns, setColumns] = useState(
        useMemo(() => [], [])
    );


    useEffect(() => {
        if(props?.columns?.length > 0){
            setColumns(props.columns);
            fetchData(currentPage);
        }
    }, [props]);

    const callPostApi = (url, data, headerMap, successCallBack, failedCallBack) => {
        apiCaller.callPostApi(url, data, headerMap, successCallBack, failedCallBack);
    }

    const fetchData = async (page, size = perPage) => {
        setLoading(true);
        var jsonRequest = {
            "page": page - 1,
            "size": size,
            searchFilters: props.specificFilters ? props.specificFilters : props.filters ? props.filters.searchFilters : [],
            sortRules: props.filters ? props.filters.sortRules : [],
        };
        // var jsonRequest = {
        //     "pageNumber": page - 1,
        //     "pageSize": size,
        // };
        callPostApi(props.paginationUrl, jsonRequest, {}, (response) => {
            setData(response?.data || []);
            // setData(response.responsePacket.data);
            setTotalRows(response.totalItems);
            setLoading(false);
        }, (error) => {
            setLoading(false);
            console.error(error);
        })
    };

    const handlePageChange = page => {
        fetchData(page);
        setCurrentPage(page);
    };

    const handleChange = ({ selectedRows }) => {
        // You can set state or dispatch with something like Redux so we can use the retrieved data
        props.setDeleteAbleRowsData(selectedRows)
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchData(1, newPerPage);
        setPerPage(newPerPage);
    };
    return (
        <>
            {props.selectedAble ?

                <DataTable
                    className="pagination-data-table"
                    title=""
                    columns={columns}
                    data={data}
                    pagination={props.paginationStatus}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    customStyles={customStyles}
                    selectableRows
                    onSelectedRowsChange={handleChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    persistTableHead
                /> :
                <DataTable
                    className="pagination-data-table"
                    title=""
                    columns={columns}
                    data={data}
                    pagination={props.paginationStatus}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationDefaultPage={currentPage}
                    customStyles={customStyles}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    persistTableHead
                />
            }
        </>

    );
}

export default memo(PaginationDataTable);